import React, { useEffect, useMemo, useState } from "react";
import { useSettingsStore, useStore } from "../../../store";
import { get } from "lodash";
import StepWizard from "react-step-wizard";
import Panel from "../../../components/panel";
import Search from "../../../components/search";
import { Col, Row } from "react-grid-system";
import Section from "../../../components/section";
import Title from "../../../components/ui/title";
import StepOne from "../components/agreement-create/StepOne";
import StepTwo from "../components/agreement-create/StepTwo";
import StepThree from "../components/agreement-create/StepThree";
import StepFour from "../components/agreement-create/StepFour";
import StepFive from "../components/agreement-create/StepFive";
import StepSix from "../components/agreement-create/StepSix";
import { useGetOneQuery } from "../../../hooks/api";
import { KEYS } from "../../../constants/key";
import { URLS } from "../../../constants/url";
import { OverlayLoader } from "../../../components/loader";
import { useTranslation } from "react-i18next";
import {
  buildPledgersSelect,
  mapApiClientToStore,
  mapApiCommissionsToStore,
  mapApiObjectsToStore,
  mapApiPledgersToStore,
} from "../utils/agreementEditHydration";

const AgreementUpdateContainer = ({ id }) => {
  const setBreadcrumbs = useStore((state) =>
    get(state, "setBreadcrumbs", () => {})
  );
  const initAgreementEdit = useSettingsStore((state) =>
    get(state, "initAgreementEdit", () => {})
  );
  const { t } = useTranslation();
  const [isHydrated, setIsHydrated] = useState(false);
  let { data, isLoading } = useGetOneQuery({
    id,
    key: KEYS.agreements,
    url: `${URLS.agreements}/show`,
  });
  const breadcrumbs = useMemo(
    () => [
      {
        id: 1,
        title: t("Agreements"),
        path: "/agreements",
      },
      {
        id: 2,
        title: t("Edit  agreement"),
        path: "/agreements/edit",
      },
    ],
    [t]
  );

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
  }, [breadcrumbs, setBreadcrumbs]);

  useEffect(() => {
    setIsHydrated(false);
  }, [id]);

  useEffect(() => {
    const agreementData = get(data, "data");
    if (!agreementData || !id) {
      return;
    }
    const apiPledgers = get(agreementData, "pledgers", []);
    initAgreementEdit({
      agreement: {
        ...agreementData,
        pledgersSelect: buildPledgersSelect(apiPledgers),
      },
      insurer: mapApiClientToStore(get(agreementData, "insurant")),
      beneficiary: mapApiClientToStore(get(agreementData, "beneficiary")),
      pledgers: mapApiPledgersToStore(apiPledgers),
      objects: mapApiObjectsToStore(get(agreementData, "objectOfInsurance", [])),
      commissions: mapApiCommissionsToStore(
        get(agreementData, "commission", get(agreementData, "commissions", []))
      ),
    });
    setIsHydrated(true);
  }, [data, id, initAgreementEdit]);

  if (isLoading || !isHydrated) {
    return <OverlayLoader />;
  }

  return (
    <>
      <Panel>
        <Row>
          <Col xs={12}>
            <Search />
          </Col>
        </Row>
      </Panel>
      <Section>
        <Row>
          <Col xs={12}>
            <Title>{t("Продажа страховых полисов")}</Title>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <StepWizard isHashEnabled={true}>
              <StepOne hashKey={"one"} id={id} />
              <StepTwo hashKey={"two"} id={id} />
              <StepThree hashKey={"three"} id={id} />
              <StepFour hashKey={"four"} id={id} />
              <StepFive hashKey={"five"} id={id} />
              <StepSix hashKey={"six"} id={id} />
            </StepWizard>
          </Col>
        </Row>
      </Section>
    </>
  );
};

export default AgreementUpdateContainer;
